/**
 * @desc Config-driven model of the EDEN RFQ-to-execution workflow — one entry
 * per stage with its products — powers both the homepage journey rail and
 * the sidebar's grouped navigation sections
 */
export const journeyStages = [
	{
		id: 'outreach',
		number: 1,
		icon: 'outreach',
		color: '#00684b',
		tint: 'rgba(0,104,75,0.12)',
		title: 'Get RFQ',
		blurb: 'Bring in customer requests',
		products: [
			{
				id: 'customer-outreach',
				icon: 'customer-outreach',
				name: 'Customer Outreach',
				blurb:
					'Proactively reach customers and turn interest into inbound RFQs.',
				route: '/customer-outreach',
			},
		],
	},
	{
		id: 'capture',
		number: 2,
		icon: 'capture',
		color: '#0f7c8c',
		tint: 'rgba(15,124,140,0.12)',
		title: 'Capture RFQ Demand',
		blurb: 'Structure customer demand',
		products: [
			{
				id: 'eagle',
				icon: 'eagle',
				name: 'Eagle: Customer RFQs',
				blurb:
					'Pulls RFQs straight from customer emails into structured demand.',
				route: '/customer-rfqs',
			},
			{
				id: 'bom-cleaner',
				icon: 'bom-cleaner',
				name: 'BOM Cleaner',
				blurb:
					'Cleans and standardizes messy BOM files before they enter the pipeline.',
				route: '/bom-cleaner',
			},
		],
	},
	{
		id: 'match',
		number: 3,
		icon: 'match',
		color: '#0c2340',
		tint: 'rgba(12,35,64,0.10)',
		title: 'Find Stock & Match',
		blurb: 'Search supply and validate fit',
		products: [
			{
				id: 'chipsfinder',
				icon: 'chipsfinder',
				name: 'ChipsFinder',
				blurb: 'Searches global stock availability across distributors.',
				route: '/chipsfinder-logs',
			},
			{
				id: 'brand-matching',
				icon: 'brand-matching',
				name: 'Brand Matching',
				blurb: 'Matches RFQ lines to the right supplier stock by brand.',
				route: '/eagle-bobcat-match',
			},
			{
				id: 'price-match',
				icon: 'price-match',
				name: 'Franchise-line Price Match',
				blurb:
					'Validates pricing against franchised brand lines - a live product outside of EDEN.',
			},
		],
	},
	{
		id: 'source',
		number: 4,
		icon: 'source',
		color: '#7030a0',
		tint: 'rgba(112,48,160,0.12)',
		title: 'Source & Compare Offers',
		blurb: 'Reach suppliers and compare responses',
		products: [
			{
				id: 'raven',
				icon: 'raven',
				name: 'Raven (Multi-Brand)',
				blurb: 'Sends bulk RFQs to suppliers and collects their offers.',
				route: '/raven',
			},
			{
				id: 'mass-mail',
				icon: 'mass-mail',
				name: 'Mass Mail (Single-Brand)',
				blurb: 'Sends RFQ mass mail to suppliers for a single brand.',
				route: '/mass-mail',
			},
			{
				id: 'bobcat',
				icon: 'bobcat',
				name: 'Bobcat: Supplier Prices',
				blurb: 'Tracks and compares supplier price responses.',
				route: '/supplier-prices',
			},
			{
				id: 'price-book',
				icon: 'price-book',
				name: 'Price Book',
				blurb: 'Central record of negotiated and quoted prices.',
				route: '/franchised-line-pricebook',
			},
		],
	},
	{
		id: 'fulfil',
		number: 5,
		icon: 'fulfil',
		color: '#c2660a',
		tint: 'rgba(194,102,10,0.12)',
		title: 'Quote, Order & Fulfil',
		blurb: 'Convert opportunities into execution',
		products: [
			{
				id: 'po-extractor',
				icon: 'po-extractor',
				name: 'PO Extractor',
				blurb: 'AI-extracts PO line items straight from customer emails.',
				route: '/order-management?view=po-extractor',
			},
			{
				id: 'order-manager',
				icon: 'order-manager',
				name: 'Order Manager',
				blurb: 'Tracks open orders through to fulfillment.',
				route: '/order-management',
			},
			{
				id: 'project-jet',
				icon: 'project-jet',
				name: 'Project Jet',
				blurb: 'Automated order execution - a live product outside of EDEN.',
			},
		],
	},
	{
		id: 'learn',
		number: 6,
		icon: 'learn',
		color: '#3f7d3a',
		tint: 'rgba(63,125,58,0.12)',
		title: 'Manage Performance',
		blurb: 'Monitor performance and manage exceptions',
		products: [
			{
				id: 'customer-report',
				icon: 'customer-report',
				name: 'Customer Report',
				blurb: 'Customer-level sales and account performance.',
				route: '/customer-report',
			},
			{
				id: 'mpn-report',
				icon: 'mpn-report',
				name: 'MPN Report',
				blurb: 'Part-number level sales and pricing history.',
				route: '/mpn-report',
			},
			{
				id: 'learn-centre',
				icon: 'learn-centre',
				name: 'Learn Center',
				blurb: 'Training resources and onboarding guides.',
				route: '/learn-centre',
			},
			{
				id: 'backorder-management',
				icon: 'backorder-management',
				name: 'Backorder Management',
				blurb: 'Track and manage orders awaiting stock.',
				route: '/backorder-management',
			},
		],
	},
];

export const FEATURED_PATHS = new Set(
	journeyStages.flatMap((stage) =>
		stage.products.filter((p) => p.route).map((p) => p.route.split('?')[0]),
	),
);
